export default __webpack_public_path__ + "static/media/VOLT.a013190e.png";